import { ReeferThemeProvider, useToast } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';
import { useEffect, useMemo } from 'react';
import { useMatch } from 'react-router';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { deriveCustomReeferTheme } from '@jane/bloom/resources/theme';
import { toastVariant } from '@jane/bloom/utils/toastVariant';

import styles from './wrapper.module.css';

export function BloomWrapper({ children }: PropsWithChildren) {
  const { theme, toast: toastMessage } = useRootLoaderData();
  const reeferCustomTheme = useMemo(
    () => deriveCustomReeferTheme(theme),
    [theme]
  );
  const toast = useToast();
  const isCheckout = useMatch('/checkout');

  useEffect(() => {
    if (toastMessage?.message) {
      toast.add({
        label: toastMessage.message,
        time: toastMessage.duration,
        variant: toastVariant(toastMessage.type),
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toastMessage]);

  return (
    <ReeferThemeProvider mode="server" theme={reeferCustomTheme}>
      <div
        className={clsx(styles['bodyContainer'], {
          [styles['bodyContainer--fullViewportHeight']]: !isCheckout,
        })}
      >
        {children}
      </div>
    </ReeferThemeProvider>
  );
}
